import { render, staticRenderFns } from "./AddProtocolLinkDlg.vue?vue&type=template&id=4a87e49e&"
import script from "./AddProtocolLinkDlg.vue?vue&type=script&lang=js&"
export * from "./AddProtocolLinkDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports